export class ErrorCodeConstants {
  public static ERROR_VALIDATE = 'EA0002'
  public static ERROR_TOKEN_INVALID = 401
  public static ERROR_TOKEN_EXPIRED = 401
  public static STATUS_CODE_SUCCESS = 200
  public static STATUS_CODE_INTERNAL_SERVER_ERROR = 500
  public static STATUS_CODE_PASSWORD_EXPIRED = 403
}
